export const transportOrdersSortFieldMap: Record<string, string> = {
  weightAtUnloading: "unloaded_weight",
  deliveryStatus: "status",
  salesContract: "sales_contract_number",
  transportRate: "transport_rate",
  product: "product_name",
  buyer: "buyer_name",
  unloadingDate: "unloading_date",
  salesinvoice: "sales_invoice",
  weightAtLoading: "loaded_weight",
  entryStatus: "entry_status",
  purchaseDeductions: "purchase_deductions",
  driver: "driver_name",
  driverManager: "driver_manager_email",
  purchasePrice: "purchase_price",
  purchaseInvoice: "purchase_invoice",
  salesDeduction: "sales_deductions",
  loadingLocation: "loading_address",
  loadingCity: "loading_city",
  loadingCountry: "loading_country",
  loadingDate: "loading_date",
  carrier: "transporter_name",
  trucks: "truck_number",
  salesPrice: "sales_price",
  unloadingLocation: "unloading_address",
  unloadingCity: "unloading_city",
  unloadingCountry: "unloading_country",
  trailers: "trailer_number",
  purchaseContract: "purchase_contract_number",
  seller: "supplier_name",
  number: "number",
};

export const forwardingOrdersSortFieldMap: Record<string, string> = {
  deliveryStatus: "status",
  clientRate: "client_rate",
  transportRate: "transport_rate",
  forwarder: "forwarding_officer",
  salesInvoice: "sales_invoice",
  weight: "weight",
  entryStatus: "entry_status",
  driver: "driver_name",
  driverManager: "driver_manager_email",
  purchaseInvoice: "purchase_invoice",
  buyer: "client_name",
  loadingLocation: "loading_address",
  loadingCity: "loading_city",
  loadingCountry: "loading_country",
  carrier: "transporter_name",
  profit: "profit",
  trucks: "truck_number",
  date: "date",
  unloadingLocation: "unloading_address",
  unloadingCity: "unloading_city",
  unloadingCountry: "unloading_country",
  trailers: "trailer_number",
  number: "number",
};

export const deliveriesSortFieldMap: Record<string, string> = {
  date: "date",
  deliveryStatus: "status",
  entryStatus: "entry_status",
  driver: "driver_name",
  driverManager: "driver_manager_email",
  loadingAddress: "loading_address",
  loadingCity: "loading_city",
  loadingCountry: "loading_country",
  unloadingAddress: "unloading_address",
  unloadingCity: "unloading_city",
  unloadingCountry: "unloading_country",
  transportRate: "transport_rate",
};

export const driversSortFieldMap: Record<string, string> = {
  firstName: "first_name",
  lastName: "last_name",
  personalCode: "personal_code",
  phone: "phone",
  companyId: "company",
  email: "email",
  managerId: "manager_email",
};

export const contractsSortFieldMap: Record<string, string> = {
  broker: "broker",
  deliveredWeight: "delivered_weight",
  estimatedWeight: "estimated_weight",
  remainingWeight: "remaining_weight",
  missingWeight: "missing_weight",
  product: "product_name",
  price: "price",
  client: "client_name",
  contractNumber: "contract_number",
  date: "date",
  brokerInvoice: "broker_invoice",
  paymentDeadlineDays: "payment_deadline_days",
  location: "address",
  country: "country",
  city: "city",
  weight: "weight",
  entryStatus: "entry_status",
  signed: "signed",
};

export const companiesSortFieldMap: Record<string, string> = {
  name: "name",
  registryCode: "registry_code",
};
